import { render, staticRenderFns } from "./ManageMemberData.vue?vue&type=template&id=422beb7a&"
import script from "./ManageMemberData.vue?vue&type=script&lang=js&"
export * from "./ManageMemberData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports